<div class="cg-datatable__top-actions__links">
  <cigna-tab-group data-test="search-tab-group">
    <ng-container *ngFor="let action of actions">
      <cigna-tab
        data-test="table-action-link"
        [label]="action.label"
        [isActive]="_currentTab === action.label"
        (click)="setActiveTab(action.label); actionChange.emit(action.value)"
      >
      </cigna-tab>
    </ng-container>
  </cigna-tab-group>
</div>
